import { render, staticRenderFns } from "./DisapprovedReasonCrudData.vue?vue&type=template&id=e719a4d6"
import script from "./DisapprovedReasonCrudData.vue?vue&type=script&lang=js"
export * from "./DisapprovedReasonCrudData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports